import template from './inputLabel.html';

export function InputLabelDirective() {
  'ngInject';

  return {
    restrict: 'EA',
    replace: true,
    template,
    transclude: true,
    scope: {
      required: '@',
      labelFor: '@',
      label: '@'
    },
    link: function (scope, element, attrs) {
      attrs.$observe('required', required => {
        scope.required = scope.$eval(required);

        // NOTE: Set required to true when only the attribute is given (without any assignment)
        // e.g.: <input-label required>
        if (typeof scope.required === 'undefined') {
          scope.required = true;
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-input-label/src/inputLabel.directive.js